export default __webpack_public_path__ + "static/media/banner-triangle-mobile.426443f5.png";